import { createApp } from 'vue'
import FLinkCard from '~/js/components/linkCard'
import { LinkItem } from '~/js/models/linkItem'
import {
  favouriteArticleHandles,
  favouriteCoordinateHandles,
  isDesktop,
} from '~/js/templates/index/helpers'
import { FAVORITE_TYPE } from '~/js/services/favouriteService'

const CLASS_NAME = 'js-sectionsArticles'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    const {
      blogHandle,
      columnsSp,
      rowsSp,
      articleImgHeightSp,
      columnsPc,
      rowsPc,
      articleImgHeightPc,
    } = element.dataset

    const type =
      blogHandle === 'article'
        ? FAVORITE_TYPE.article
        : blogHandle === 'coordinate'
        ? FAVORITE_TYPE.coordinate
        : null

    const columns = Number(isDesktop() ? columnsPc : columnsSp)
    const rows = Number(isDesktop() ? rowsPc : rowsSp)

    const linkItems = JSON.parse(element.dataset.linkItems)
      .slice(0, columns * rows)
      .map((linkItem) => {
        const url = `/blogs/${blogHandle}/${linkItem.handle}`
        const isFavourite = [
          ...favouriteArticleHandles,
          ...favouriteCoordinateHandles,
        ].includes(linkItem.handle)
        return new LinkItem(linkItem, url, isFavourite)
      })

    const customImgHeightPC = Number(articleImgHeightPc)
      ? Number(articleImgHeightPc)
      : null
    const customImgHeightSP = Number(articleImgHeightSp)
      ? Number(articleImgHeightSp)
      : null
    const height = isDesktop() ? customImgHeightPC : customImgHeightSP

    createApp({
      name: 'SectionsArticles',
      components: { FLinkCard },
      data() {
        return {
          columns,
          height,
          linkItems,
          type,
        }
      },
    }).mount(element)
  })
})
